export function initializePayPalAnalytics(analyticsData, onBeaconCreate) {
  if (window?.PAYPAL?.analytics?.instance) {
    return;
  }

  const options = {
    data: {
      tenant_name: "braintree",
      env: process?.env?.RAILS_ENV,
      env_id: process?.env?.RAILS_ENV,
      env_name: process?.env?.RAILS_ENV,
      pgrp: "apply.braintreepayments.com:application_form",
      comp: "braintree_apply",
      product: "braintree_apply",
      event_name: "setup",
      ...analyticsData
    },
    onBeaconCreate
  };

  window?.PAYPAL?.analytics?.setup(options);
}

export function trackImpression(page) {
  const options = {
    data: { page }
  };

  window?.PAYPAL?.analytics?.instance?.recordImpression(options);
}

export function trackClick(link) {
  const options = {
    data: { link }
  };

  window?.PAYPAL?.analytics?.instance?.recordClick(options);
}

export function startCPLTracking(event_name, identifier) {
  const data = { event_name };

  window?.PAYPAL?.analytics?.startCPLTracking(data, identifier);
}

export function endCPLTracking(event_name, identifier, page) {
  const data = { event_name, page };

  window?.PAYPAL?.analytics?.endCPLTracking(data, identifier);
}
